import React, { useState, useEffect } from 'react';
import { Checkbox, FormControl } from '@mui/material';
import PropTypes from 'prop-types';
import FieldNames from '../../../defaults/FieldNames.json';

const BlueAlien = "#1976d2";
export default function DetailsCheckbox({detail, field, onFieldChange, allFields, fieldIsStatic = false}) {
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if(field === allFields.isFunded || field === allFields.isVegetationManual || fieldIsStatic){
      if(detail && detail?.attributes){
        setIsDisabled(true);
      }
    } 
  }, [detail, field, allFields]);

  return(
    <FormControl variant="standard">
      <Checkbox style={{padding: '0', margin: '0 5px 0 0px', borderColor: BlueAlien}} id={`${field}`}
        disabled={isDisabled}
        checked={(detail && detail?.attributes && detail?.attributes[field] === FieldNames.yesNo.yes) ? true : false} 
        onChange={(event) => {
          let isChecked = FieldNames.yesNo.no
          if(event.target.checked){
            isChecked = FieldNames.yesNo.yes
          }
          onFieldChange(field, isChecked);
        }} 
      />
    </FormControl>
  )
}